import { useCallback } from "react"
import * as signalR from "@microsoft/signalr"
import { getOrCreateApplicationHubConnection } from "../infrastructure/signalr-service"
import { useCurrentOrganization } from "@/modules/organizations/hooks/use-organizations"
import { CvProcessedDto } from "@/modules/recruitment/candidates/dtos/cv-upload"

export function useApplicationHub() {
  const organization = useCurrentOrganization()

  const onCvProcessed = useCallback(
    (handler: (dto: CvProcessedDto) => void): (() => void) => {
      if (!organization?.id) {
        return () => {}
      }

      const { connection, start } = getOrCreateApplicationHubConnection(
        organization.id,
      )

      if (connection.state === signalR.HubConnectionState.Disconnected) {
        start()
      }

      connection.on("CvProcessed", handler)

      return () => {
        connection.off("CvProcessed", handler)
      }
    },
    [organization?.id],
  )

  return { onCvProcessed }
}
